import React from 'react';
import { useEffect, useState } from 'react';

import modalImagen from '../../assets/img/modales/modalimagen.jpeg';
import './Inicio.css';
import Carrusel from './components/Carrusel';
import Card1 from './components/Card1';
import Card2 from './components/Card2';
import CardDestacados from './components/CardDestacados';
import CardAction from './components/CardAction';
import CardEstadisticas from './components/CardEstadisticas';
import CardMapa from './components/CardMapa';

const Inicio = () => {

    const [showModal, setShowModal] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setShowModal(false), 10000);
        return () => clearTimeout(timer);
    }, []);


    return (

        <>

            {showModal && (
                <div className="welcome-modal" role="dialog" aria-modal="true" aria-label="Aviso">
                    <div className="welcome-modal__overlay" onClick={() => setShowModal(false)} />
                    <div className="welcome-modal__box">
                        <button
                            type="button"
                            className="welcome-modal__close"
                            aria-label="Cerrar"
                            onClick={() => setShowModal(false)}
                        >
                            ×
                        </button>
                        <img src={modalImagen} alt="Aviso" className="welcome-modal__img" />
                    </div>
                </div>
            )}

            {/**_______ */}

            <Carrusel />

            <Card1 />

            <Card2 />

            <CardDestacados />

            <CardAction />

            <CardEstadisticas />

            <CardMapa />
        </>

    );
};

export default Inicio;
